var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-card" }, [
    _c(
      "div",
      { staticClass: "modal-card-body" },
      [
        _c("h1", { staticClass: "title is-4" }, [
          _vm._v("Agregar nuevos metadatos"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field has-addons" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.prevOption } },
              [_c("i", { staticClass: "fas fa-arrow-left" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control is-expanded" }, [
            _c("div", { staticClass: "select is-fullwidth" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aspectoSeleccionadoId,
                      expression: "aspectoSeleccionadoId",
                    },
                  ],
                  attrs: { name: "aspecto" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.aspectoSeleccionadoId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.aspectosDisponibles, function (aspecto) {
                  return _c(
                    "option",
                    { key: aspecto.id, domProps: { value: aspecto.id } },
                    [_vm._v(_vm._s(aspecto.nombre))]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.nextOption } },
              [_c("i", { staticClass: "fas fa-arrow-right" })]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.aspectoSeleccionado
          ? _c("metadatos", {
              key: `meta-form-aspect-${_vm.aspectoSeleccionado.id}`,
              ref: "metadatosForm",
              attrs: {
                "force-edit": true,
                "hide-save-button": true,
                aspecto: _vm.aspectoSeleccionado,
                "can-edit": true,
                bordered: true,
                "is-on-modal": true,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "buttons is-right" }, [
          _c(
            "a",
            {
              staticClass: "button is-light",
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v(" Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button is-light",
              on: { click: _vm.saveWithoutMetadatos },
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(" Agregar sin metadatos\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "button is-primary",
              on: { click: _vm.saveWithMetadatos },
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(" Guardar con metadatos\n      "),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }